import queryString from "query-string";
import { useAsync } from "react-use";
import { AsyncState } from "react-use/lib/useAsyncFn";

interface Options {
  type?: "ir" | "pr";
  from?: Date;
  to?: Date;
  tags?: string | string[];
  filter?: string;
  lang?: "sv" | "en";
}

type Attachment = {
  // Display name for file
  file_title: string;
  // MIME type for file, e.g. application/pdf
  content_type: string;

  // The url where the file can be retrieved.
  url: string;

  // Attachment tags
  // ':generated' is an attachment generated by MFN (usually the item in PDF format)
  // ':primary' is an attachment containing the news item content
  tags: string[];
};

type NewsContent = {
  // The title of the press release
  title: string;

  // A url friendly version of the title
  slug: string;

  // The content of the news, including preamble, footers and attachemtns
  // formatted as html
  html: string;

  // RFC3339 time format, 2006-01-02T15:04:05Z07:00
  publish_date: string;

  // Attachments that augments the news item.
  attachments: Attachment[];
};

type MfnItem = {
  content: NewsContent;
};

export interface MfnResponse {
  items: MfnItem[];
}

const id = "73e3aea6-12b5-43e6-97dd-447bbfb83d66";

export const useFetchForm = (): AsyncState<MfnResponse> => {
  const url = `https://feed.mfn.se/v1/feed/${id}.json`;

  return useAsync(async () => {
    const response = await fetch(url);

    if (response.ok) {
      return await response.json();
    } else {
      console.error({ status: response.status, message: response.statusText });
    }
  });
};

export const useInvestorData = (options: Options): AsyncState<MfnResponse> => {
  const url = `https://feed.mfn.se/v1/feed/${id}.json`;
  const { type, tags, lang, filter } = options;
  const from = options.from?.toISOString();
  const to = options.to?.toISOString();

  /**
   * Must use a custom string for tags since
   * mfn:s tag param does not accept arrays
   */
  let tagString = "";
  Array.isArray(tags)
    ? tags.map((tag) => (tagString = tagString + `&tag=${tag}`))
    : (tagString = `&tag=${tags}`);

  const urlFormatted = queryString.stringifyUrl({
    url,
    query: {
      ...(type && { type }),
      // ...(to && { to }),
      // ...(from && { from }),
      ...(lang && { lang }),
      ...(filter && { filter }),
    },
  });

  return useAsync(async () => {
    const response = await fetch(`${urlFormatted}${tags ? tagString : ''}`);

    if (response.ok) {
      return await response.json();
    } else {
      console.error({ status: response.status, message: response.statusText });
    }
  });
};
